










































import { MediaItem, Work } from "@/api/models";
import { OptionItem, SiteState, SubmissionState } from "@/store/types";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import { emptyString, notEmptyString } from "@/api/validators";
import { bus } from "@/main";
import HelpWidget from "./HelpWidget.vue";
import DisplayOptionSet from "./DisplayOptionSet.vue";
import { VueEditor } from "vue2-editor";
import { customToolbar, textChange } from "@/settings/wysiwyg";

@Component({
  components: {
    HelpWidget,
    VueEditor,
    DisplayOptionSet,
  },
  filters: {},
})
export default class MediaForm extends Vue {
  @Prop({ default: () => new Work() }) work: Work;
  @Prop({ default: "" }) mediaItemId: string;
  @Prop({ default: -1 }) index: number;
  @State("site") site: SiteState;
  @State("submission") submission: SubmissionState;
  @Action("assignSubmission", { namespace: "submission" })
  assignSubmission: Function;

  item: MediaItem = new MediaItem();

  updating = false;

  created() {
    this.sync();
    bus.$on("saving-work", ({ workId }) => {
      if (workId === this.work._id) {
        this.updating = false;
        this.assignItem(false);
      }
    });
    bus.$on("media-saved", ({ mediaItemId }) => {
      if (mediaItemId === this.mediaItemId) {
        this.sync();
      }
    });
  }

  get isNew() {
    return emptyString(this.work._id, 12);
  }

  get hasItem() {
    const { mime } = this.item;
    return notEmptyString(mime);
  }

  get isVideo() {
    return (
      this.hasItem &&
      (this.item.type === "video" || this.item.mime.startsWith("video"))
    );
  }

  get displayOptionRows(): Array<OptionItem> {
    return [];
  }

  get mediaId() {
    return ["media-item-", this.mediaItemId].join("-");
  }

  get mediaDescLabel() {
    return this.site.label("description");
  }

  get titleHelpKey() {
    return "title_help";
  }

  get textEditorId() {
    return ["text-editor", "text-item", this.work._id, this.item._id].join("-");
  }

  get toolbar() {
    return customToolbar;
  }

  htmlChange(delta, source) {
    this.item.description = textChange(delta, source, this.item.description);
  }

  updateDisplayOptions(displayOpts = null, mediaId = "") {
    if (displayOpts instanceof Object && mediaId === this.mediaItemId) {
      this.item.displayOptions = displayOpts;
    }
  }

  update() {
    if (!this.updating) {
      this.updating = true;
      this.assignItem();
    }
  }

  assignItem(tempSave = true) {
    const workIndex = this.submission.works.findIndex(
      (w) => w._id === this.work._id
    );
    if (workIndex >= 0) {
      const mi = this.submission.works[workIndex].mediaItems.findIndex(
        (item) => item._id === this.mediaItemId
      );
      if (mi >= 0) {
        this.submission.works[workIndex].mediaItems[mi] = this.item;
        this.assignSubmission(this.submission);
        if (tempSave) {
          this.$ls.set("submission", this.submission);
        }
      }
    }
    bus.$emit("active", true);
    bus.$emit("media-updated", { workId: this.work._id });
    setTimeout(() => {
      this.updating = false;
    }, 125);
  }

  sync() {
    if (notEmptyString(this.mediaItemId, 12) || this.mediaItemId === "_new") {
      const matched = this.work.mediaItems.find(
        (mi) => mi._id === this.mediaItemId
      );
      if (matched instanceof MediaItem) {
        matched.type = "text";
        matched.source = "db";
        this.item = matched;
      }
    }
  }

  toggleSort() {
    bus.$emit("toggle-sort", true);
  }

  remove() {
    bus.$emit("remove-media", {
      workId: this.work._id,
      mediaItemId: this.mediaItemId,
      index: this.index,
    });
  }

  @Watch("item.title")
  changeItem() {
    this.update();
  }

  @Watch("item.url")
  changeUrl() {
    this.update();
  }

  @Watch("item.description")
  changeDescription() {
    this.update();
  }
}
